import { useMutation, useQueryClient } from "@tanstack/react-query";

import { userSettingsQueryKey } from "@/hooks/queries/useGetUserSettings";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse, UpdateUserSettingsRequest, UserSettings } from "@/types";

export const useUpdateSetUserSettings = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: UpdateUserSettingsRequest) => {
      const path = "user-settings";
      const res = await guacHttpClient.patch<
        UserSettings,
        HttpResponse<UserSettings>,
        UpdateUserSettingsRequest
      >(path, request);
      return res.data;
    },
    onMutate: async (request) => {
      await queryClient.cancelQueries({ queryKey: userSettingsQueryKey });
      const previous =
        queryClient.getQueryData<UserSettings>(userSettingsQueryKey);
      if (previous) {
        queryClient.setQueryData<UserSettings>(userSettingsQueryKey, {
          ...previous,
          ...request,
        });
      }
      return { previous };
    },
    onSuccess: (updatedData, request) => {
      // Keep requested settings when an older backend response omits them.
      queryClient.setQueryData(userSettingsQueryKey, { ...updatedData, ...request });
    },
  });
};
